<template #default>
<div>
  <v-dialog class="rounded-lg" v-model="responseDialog" scrollable max-width="1200px" transition="dialog-transition">
    <v-card class="rounded-lg pa-2">
      <v-card-title class="secondary--text"> صورتحساب های مرجع </v-card-title>

      <v-card-text>
        <m-datatable
          class="mt-4"
          :headers="responseHeaders"
          :items="response"
          :isDialog="true"
          :show-export-btns="false"
          :show-filter-row="false"
        >
          <template #item.detail="{ item }">
<!--            <detail-link :to="to(item)" />-->
            <template>
            <v-tooltip bottom color="info">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs"
                       v-on="on"
                       color="info white--text"
                       icon
                       @click="showReferenceDetail(item.taxSerialNumber)"
                >
                  <v-img max-width="20" max-height="20" src="/img/icons/info_circle.svg"></v-img>
                </v-btn>
              </template>
              جزئیات
            </v-tooltip>
            </template>
          </template>
        </m-datatable>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-card class="white rounded-lg">
    <v-card-title class="secondary--text">{{ title }}</v-card-title>
    <v-card-actions class="ltr" v-if="hasActiveExtension('MOADIAN')">
      <v-btn
          v-if="factor.InvoiceSubjectCode != 4"
          class="primary mx-1 rounded-lg"
          @click="backFromBuyMoadianFactor(id)"
          depressed
      >ثبت برگشت از فروش
      </v-btn>
      <v-btn
          v-if="factor.InvoiceSubjectCode != 3"
          class="secondary mx-1 rounded-lg"
          @click="revokeMoadianFactor(id)"
          depressed
      >ابطال صورتحساب
      </v-btn>
      <v-btn
          v-if="factor.InvoiceSubjectCode != 1 || [15, 16, 17].includes(factor.StatusCode)"
          class="info mx-1 rounded-lg"
          @click="getMoadianReferences(id)"
          depressed
      >صورتحساب های مرجع
      </v-btn>
    </v-card-actions>
    <v-card-text class="pa-3">
      <v-row>
        <v-col cols="12" md="4" v-if="factor.taxSerialNumber">
          <v-text-field class="rounded-lg" label="شماره منحصر به فرد مالیاتی" v-model="factor.taxSerialNumber" disabled/>
        </v-col>
        <v-col cols="12" md="4" v-if="factor.UniqueId">
          <v-text-field class="rounded-lg" label="کد یکتای ثبت صورتحساب" v-model="factor.UniqueId"
                        disabled/>
        </v-col>
        <v-col cols="12" md="4" v-if="factor.trackingId">
          <v-text-field class="rounded-lg" label="کد رهگیری" v-model="factor.trackingId" disabled/>
        </v-col>
        <v-col cols="12" md="4" v-if="factor.invoiceNumber">
          <v-text-field class="rounded-lg" label="شماره صورتحساب" v-model="factor.invoiceNumber" disabled/>
        </v-col>
        <v-col cols="12" md="4" v-if="factor.invoiceDate">
          <v-text-field class="rounded-lg" label="تاریخ صورتحساب" v-model="factor.invoiceDate" disabled/>
        </v-col>
        <v-col cols="12" md="4" v-if="factor.createdDate">
          <v-text-field class="rounded-lg" label="تاریخ ایجاد" v-model="factor.createdDate" disabled/>
        </v-col>
        <v-col cols="12" md="4" v-if="factor.InvoiceTypeTitle">
          <v-text-field class="rounded-lg" label="نوع صورتحساب" v-model="factor.InvoiceTypeTitle" disabled/>
        </v-col>
        <v-col cols="12" md="4" v-if="factor.InvoicePatternTitle">
          <v-text-field class="rounded-lg" label="الگوی صورتحساب" v-model="factor.InvoicePatternTitle" disabled/>
        </v-col>
        <v-col cols="12" md="4" v-if="factor.InvoiceSubjectTitle">
          <v-text-field class="rounded-lg" label="موضوع صورتحساب" v-model="factor.InvoiceSubjectTitle" disabled/>
        </v-col>
        <v-col cols="12" md="4" v-if="factor.sellerUserNationalCode">
          <v-text-field class="rounded-lg" label="شناسه/کد ملی فروشنده" v-model="factor.sellerUserNationalCode" disabled/>
        </v-col>
        <v-col cols="12" md="4" v-if="factor.sellerUserFullName">
          <v-text-field class="rounded-lg" label="نام فروشنده" v-model="factor.sellerUserFullName" disabled/>
        </v-col>
        <v-col cols="12" md="4" v-if="factor.sellerUserCompanyName">
          <v-text-field class="rounded-lg" label="نام شرکت فروشنده" v-model="factor.sellerUserCompanyName" disabled/>
        </v-col>
        <v-col cols="12" md="4" v-if="factor.BuyerTypeTitle">
          <v-text-field class="rounded-lg" label="نوع خریدار" v-model="factor.BuyerTypeTitle" disabled/>
        </v-col>
        <v-col cols="12" md="4" v-if="factor.StatusTitle || factor.statusTitle">
          <v-text-field class="rounded-lg" label="وضعیت" v-model="factor.StatusTitle || factor.statusTitle" disabled/>
        </v-col>
        <v-col cols="12" md="4" v-if="factor.SaleTypeTitle">
          <v-text-field class="rounded-lg" label="نوع فروش" v-model="factor.SaleTypeTitle" disabled/>
        </v-col>
        <v-col cols="12" md="4" v-if="factor.PaymentType">
          <v-text-field class="rounded-lg" label="نوع پرداخت" v-model="factor.PaymentType" disabled/>
        </v-col>
      </v-row>

      <v-row v-if="factor.invoiceItems">
        <v-col clos="12">
          <m-datatable
              class="mt-4"
              :items="factor.invoiceItems"
              :headers="headers"
              :show-export-btns="false"
              :show-select="false"
              :show-filter-row="false"
          >

          </m-datatable>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</div>
</template>

<script>
import accountApiMixin from "@/mixin/accountMixin";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import date from "@/components/mcomponents/cleave/Date";

import {MFormMixin} from "@/components/m-form";

export default {
  name: "Form",
  components: {money, date},
  mixins: [formsMixin, accountApiMixin, MFormMixin],
  props: ["id"],
  data() {
    return {
      taxSerialNumber: null,

      detail_url: 'moadian/keysan/factor/' + this.id + '/',
      references_url: 'moadian/keysan/referencefactors/' + this.id + '/',

      responseDialog: false,
      responseHeaders: [
        {
          text: 'شماره منحصر به فرد مالیاتی',
          value: 'taxSerialNumber',
          sortable: false,
        },
        {
          text: 'وضعیت',
          value: 'statusTitle',
          sortable: false,
        },
        {
          text: 'کد رهگیری',
          value: 'trackingId',
        },
        {
          text: 'کد یکتای ثبت صورتحساب',
          value: 'uniqueId',
        },
        {
          text: 'جزئیات',
          value: 'detail',
          filterable: false,
          sortable: false,
        },
      ],
      response: null,

      factor: {},
      moadian_detail_url: 'moadian/keysan/factor/' + this.id + '/',
      moadian_references_url: 'moadian/keysan/referencefactors/' + this.id + '/',
      moadian_revoke_url: 'moadian/keysan/revoke/factor/',
      item: {},
      headers: [
        {
          text: "شناسه اختصاصی کالا",
          value: "commodityCode",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "شرح عمومی کالا",
          value: "stuffTitle",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "نوع ارز",
          value: "MoneyTypeTitle",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "نرخ ارز",
          value: "equivalentToRial",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "واحد",
          value: "UnitTypeTitle",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "تعداد",
          value: "amount",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "مبلغ واحد",
          value: "unitPrice",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "تخفیف",
          value: "discount",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "مبلغ پس از تخفیف",
          value: "totalPriceWithDiscount",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "نرخ مالیات بر ارزش افزوده",
          value: "taxPercent",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "مبلغ مالیات بر ارزش افزوده",
          value: "taxPrice",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: "مبلغ نهایی",
          value: "finalPrice",
          align: "center",
          sortable: false,
          filterable: false,
        },
      ]
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle(this.taxSerialNumber ? "جزئیات صورتحساب مرجع" : "جزئیات صورتحساب");
    },
    data_url() {
      if (this.taxSerialNumber) return this.moadian_detail_url + this.taxSerialNumber + '/'
      else return this.moadian_detail_url
    }

  },
  methods: {
    getData() {
      this.getMoadianFactor();
    },
    getMoadianFactor() {
      this.request({
        url: this.endpoint(this.data_url),
        method: "get",
        success: (data) => {
          this.factor = data;
        }
      });
    },
    getMoadianReferences(factorId) {
      this.request({
        url: this.endpoint(this.moadian_references_url),
        method: "get",
        success: (data) => {
          this.response = data.reverse();
          this.responseDialog = true;
        }
      });
    },
    revokeMoadianFactor(factorId) {
      if(this.factor.StatusCode != 14){
        let error_message = 'فاکتور در وضعیت '
        let status_title = this.factor.StatusTitle || this.factor.statusTitle
        error_message += status_title
        error_message += ' قابل ابطال نیست'
        this.notify(error_message, 'danger')

      }else {
        this.request({
          url: this.endpoint(this.moadian_revoke_url),
          method: "post",
          data: {
            factorId: factorId
          },
          success: (data)=> {
            if (data[factorId]['success'] == true) {
              this.successNotify()
            } else if (data[factorId]['success'] == false) {
              this.notify(data[factorId]['message'], 'danger')
            }
            this.getMoadianFactor()
          }
        })

      }
    },
    backFromBuyMoadianFactor(factorId) {
      this.$router.push(`/panel/factor/form/false/backFromSale?backFrom=${factorId}&backFromBuyInMoadian=true`)
    },
    showReferenceDetail(taxSerialNumber) {
      this.taxSerialNumber = taxSerialNumber;
      this.factor = {};
      this.getData();
      this.responseDialog = false;
    },
  },
};
</script>

<style scoped lang="scss">

</style>
